import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import Backend from 'i18next-http-backend';

import translationRU from '../public/locales/ru/translation.json?v=123';

const resources = {
    ru: {
        translation: translationRU,
    },
};

i18n.use(Backend)
    .use(initReactI18next)
    .init({
        resources,
        lng: 'ru',
        fallbackLng: 'ru',
        debug: true,

        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
